import inPolygon from "point-in-polygon"
class OfficesSelector {
  constructor() {
    this.selectors = document.querySelectorAll("[js-office-selector]")
    this.emptyOffice = { ID: "" }
    this.jumpToContent = false
    this.firstActiveBlock = null

    this.initSearchOfficeFilterListener()

    if (!this.selectors.length) {
      return
    }

    this.updateOfficeHref = this.selectors[0].getAttribute("js-update-office-href") || false

    const office = window.Offices.find(office => office.ID == this.selectors[0].value)
    this.updateActiveOffice(office ? office : this.emptyOffice)

    if (!this.activeOffice) {
      this.detectActiveOffice()
    }

    this.selectors.forEach(selector => selector.addEventListener("change", this.changeActiveOffice.bind(this)))
  }

  detectActiveOffice() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.findActiveOffice.bind(this))
    }
  }

  findActiveOffice(position) {
    if (window.Offices) {
      const detectedOffice = window.Offices.find(
        office =>
          office.AreaPolygon && inPolygon([position.coords.latitude, position.coords.longitude], office.AreaPolygon)
      )

      if (detectedOffice) {
        this.updateActiveOffice(detectedOffice)
      }
    }
  }

  changeActiveOffice(e) {
    const office = window.Offices.find(office => office.ID == e.target.value)
    this.jumpToContent = true

    // do not attempt to jump to the content on homepage selector
    if (e.target.getAttribute("js-update-office-href")) {
      this.jumpToContent = false
    }

    this.updateActiveOffice(office ? office : this.emptyOffice)
  }

  updateActiveOffice(office) {
    this.activeOffice = office
    this.selectors.forEach(selector => (selector.value = this.activeOffice.ID))

    const officeID = this.activeOffice?.ID || 0

    // cookie is also used on backend, see PageController
    document.cookie = `CSNZ_CurrentOfficeID=${officeID};path=/;max-age=31536000` // a year

    this.showActiveOfficeContent()
  }

  showActiveOfficeContent() {
    document.querySelectorAll(".office-content.active").forEach(el => {
      el.classList.remove("active")
    })

    // display the correct content, hide the whole block when there is no content for selected office
    document.querySelectorAll(".offices-area").forEach(block => {
      const activeContentNode = block.querySelector(`.office-content[data-office-id="${this.activeOffice.ID}"]`)

      if (activeContentNode) {
        activeContentNode.classList.add("active")

        if (this.jumpToContent && !this.firstActiveBlock) {
          this.firstActiveBlock = block
        }
      }

      block.classList.toggle("active", !!activeContentNode)
    })

    if (this.activeOffice) {
      document
        .querySelectorAll("[js-active-office-name]")
        .forEach(nameEl => (nameEl.innerText = this.activeOffice.Title))
    }

    document
      .querySelectorAll("[js-d-none-office-active]")
      .forEach(el => (el.style.display = !this.activeOffice.ID ? "" : "none"))

    document
      .querySelectorAll("[js-d-none-office-inactive]")
      .forEach(el => (el.style.display = !this.activeOffice.ID ? "none" : ""))

    // Jump to office content
    if (this.jumpToContent) {
      if (!this.firstActiveBlock) {
        this.firstActiveBlock = document.querySelector(".offices-area")
      }

      if (this.firstActiveBlock) {
        window.location.hash = this.firstActiveBlock.parentNode?.id
        this.firstActiveBlock.focus()
        this.jumpToContent = false
        this.firstActiveBlock = null
      }
    }

    // Update link location for selected office
    if (this.updateOfficeHref) {
      const link = document.querySelector(this.updateOfficeHref)
      if (link) {
        link.href = this.activeOffice.LandingPageUrl || "#"
      }
    }
  }

  initSearchOfficeFilterListener() {
    const officeFilterNode = document.querySelector(".filter-office .multiselect__tags")

    if (officeFilterNode) {
      const observer = new MutationObserver(() => {
        const selectedOffice = officeFilterNode.querySelector(".multiselect__single")

        if (selectedOffice) {
          const office = window.Offices.find(office => office.Title == selectedOffice.innerText)
          this.updateActiveOffice(office)
        }
      })

      // Start observing the target node for configured mutations
      observer.observe(officeFilterNode, { childList: true })
    }
  }
}

export default OfficesSelector
